<div class="mx-auto px-4">
  <div class="mb-4">
    <p class="titre1 mt-4">{{ 'USERS_MANAGEMENT.ROOT_SELECTION_ENTITE' | translate }}</p>
  </div>

  @if (isLoading) {
    <div class="flex justify-center items-center h-64">
      <mat-spinner color="accent"></mat-spinner>
    </div>
  }

  @if (!isLoading) {
    <div class="mb-4">
      <input type="text" [(ngModel)]="searchTerm" (ngModelChange)="filterEntities()"
        placeholder="{{ 'USERS_MANAGEMENT.SEARCH_ENTITY' | translate }}"
        class="h-12 md:h-14 w-full border border-gray-300 rounded-buttonAction px-3 py-2 focus:outline-none focus:ring-2 focus:ring-red-500 text-sm md:text-base">
      </div>
      <div class="block md:hidden">
        @if (entitesAffichees.length === 0) {
          <div class="text-center mt-8 text-gray-500">
            {{ 'COMMUN.DATATABLE_AUCUN_RESULTAT' | translate }}
          </div>
        }
        <div class="space-y-3">
          @for (element of entitesAffichees; track element) {
            <div (click)="selectEntity(element)"
              class="entity-card bg-white border border-gray-200 rounded-lg p-4 shadow-sm cursor-pointer hover:shadow-md transition-shadow">
              <div class="flex flex-col space-y-2">
                <div class="entity-name">
                  <span [class.font-bold]="element.entiteId === EEntite.ROOT_ENTITE_ID"
                    [class.text-rougeNovo]="element.entiteId === EEntite.ROOT_ENTITE_ID"
                    [style.color]="element.entiteId === EEntite.ROOT_ENTITE_ID ? null : 'var(--color-text)'">
                    {{ element.entiteNom }} @if (!element.estActif && element.entiteId !== EEntite.ROOT_ENTITE_ID) {
                    <span
                    class="text-xs text-gray-500 m-2">({{ 'ENTITE_INACTIF' | translate }})</span>
                  }
                </span>
              </div>
              <div class="entity-details space-y-1">
                <div class="flex justify-between items-center">
                  <span class="text-sm text-gray-600 font-medium">{{ 'USERS_MANAGEMENT.UNIQUE_ID' | translate }}:</span>
                  <span class="text-sm text-gray-800">{{ element.idUnique || '-' }}</span>
                </div>
                <div class="flex justify-between items-center">
                  <span class="text-sm text-gray-600 font-medium">{{ 'USERS_MANAGEMENT.NEQ' | translate }}:</span>
                  <span class="text-sm text-gray-800">{{ element.neq || '-' }}</span>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
    <div class="hidden md:block overflow-x-auto">
      <table mat-table [dataSource]="dataSource" matSort class="mat-table-novo"
        (matSortChange)="sortDataChange($event)">
        <ng-container matColumnDef="nomEntite">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-cell w-2/5 px-4 py-2"> {{
          'USERS_MANAGEMENT.ENTITY_NAME' | translate }}</th>
          <td mat-cell *matCellDef="let element" class="table-cell w-2/5 px-4 py-2 border-b">
            <span [class.font-bold]="element.entiteId === EEntite.ROOT_ENTITE_ID"
              [class.text-rougeNovo]="element.entiteId === EEntite.ROOT_ENTITE_ID"
              [style.color]="element.entiteId === EEntite.ROOT_ENTITE_ID ? null : 'var(--color-text)'">{{element.entiteNom
              }}
              @if (!element.estActif && element.entiteId !== EEntite.ROOT_ENTITE_ID) {
                <span
                class="text-xs text-gray-500 m-2">({{ 'ENTITE_INACTIF' | translate }})</span>
              }
            </span>
          </td>
        </ng-container>
        <ng-container matColumnDef="idUnique">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-cell w-2/5 px-4 py-2">{{
          'USERS_MANAGEMENT.UNIQUE_ID' | translate }}</th>
          <td mat-cell *matCellDef="let element" class="table-cell w-2/5 px-4 py-2 border-b">
            {{ element.idUnique }}
          </td>
        </ng-container>
        <ng-container matColumnDef="neq">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-cell w-1/15 px-4 py-2">{{
          'USERS_MANAGEMENT.NEQ' | translate }}</th>
          <td mat-cell *matCellDef="let element" class="table-cell w-1/5 px-4 py-2 border-b">
            {{ element.neq }}
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let element; columns: displayedColumns;" (click)="selectEntity(element)"
        class="cursor-pointer"></tr>
      </table>
      @if (dataSource.filteredData.length === 0) {
        <div class="text-center mt-2 text-gray-500">
          {{ 'COMMUN.DATATABLE_AUCUN_RESULTAT' | translate }}
        </div>
      }
    </div>
    <div class="mt-4">
      <mat-paginator [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSize" [pageIndex]="pageIndex"
        (page)="paginer($event)" [length]="totalItems" [showFirstLastButtons]="true">
      </mat-paginator>
    </div>
  }
</div>